import { ConstantPool } from '@angular/compiler';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { Params, Router, ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { FormsService } from 'src/app/services/forms.service';
import { BadeLoftService } from 'src/app/views/badeloft-pages/bade-loft.service';
import { ResponseMessageStatus, ResponseStatus } from '../../enums';

@Component({
  selector: 'app-add-update-assignment',
  templateUrl: './add-update-assignment.component.html',
  styleUrls: ['./add-update-assignment.component.css'],
})
export class AddUpdateAssignmentComponent implements OnInit {
  //#region properties
  isVisible = true;
  lst_Customer: any = [];
  lst_Invoice: any = [];
  lst_Stock: any = [];
  lst_Stock_Qty: any = [];
  lst_Parts: any = [];
  isStockSelected: boolean = true;
  lst_AddedStock: any = [];
  latestInvoices: any = [];
  @Output() hideModal = new EventEmitter();
  @Input() editAssignmentDetail: any;
  @Input() assignemntForInvoice: any;
  isStockPopOver: boolean = false;
  isQuantityExists: boolean = false;
  isPartNumberExist: boolean = false;
  isSyncCustomer: boolean = false;
  isSyncInvoice: boolean = false;
  isPartsLoading: boolean = false;
  lst_assignment: any;
  invoiceNotExist = false;
  dataToPassInSaveAssignment: any;
  isDataLoaded = false;
  isValidStockSelected: boolean = true;
  currectStockId: any;
  isNumberField: boolean;
  radioValue = '1';
  isLoadingList: boolean = false;
  //#endregion

  //#region  functions
  showModal(): void {
    this.isVisible = true;
  }

  handleOk(): void {
    this._cS.markFormGroupTouched(this._fS.addUpdateAssignmentForm);
    var formValue = this._fS.addUpdateAssignmentForm.value;
    if (!this.editAssignmentDetail && !this.invoiceNotExist) {
      if (this.lst_AddedStock.length > 0) {
        if (this._fS.addUpdateAssignmentForm.valid) {
          // var customerName = this.lst_Customer.find(
          //   (x: any) => x.value == formValue.customerId
          // ).text;
          // var transactionId = this.lst_Invoice.find(
          //   (x: any) => x.value == formValue.invoiceId
          // ).text;
          var body: any;
          body = {
            customerID: this.dataToPassInSaveAssignment.customerID,
            customerName: formValue.customerId,
            transactionID: this.dataToPassInSaveAssignment.transactionID,
            invoiceNo: this.dataToPassInSaveAssignment.invoiceNo,
            stocks: this.lst_AddedStock,
            note: formValue.notes ? formValue.notes : '',
            poNumber: formValue.purchaseOrder,
          };
          if (this.editAssignmentDetail)
            body['id'] = this.editAssignmentDetail.id;

          this.lst_AddedStock.forEach((element: any) => {
            if (!element.id) {
              this.isStockSelected = false;
            }
          });
          if (this.isStockSelected) {
            this._blS.CreateAssignment(body).subscribe((res) => {
              if (res) {
                if (
                  res.responseStatus == ResponseStatus.Success &&
                  res.result
                ) {
                  this._cS.displayMessage(
                    ResponseMessageStatus.success,
                    res.message
                  );
                  this.handleCancel(res.result);

                  // this.lst_assignment.push({
                  //   customerID: body.customerId,
                  //   customerName: body.customerName,
                  //   transactionID: body.invoiceId,
                  //   invoiceNo: body.transactionId,
                  //   stocks: this.lst_AddedStock,
                  //   note: body.notes ? body.notes : '',
                  //   });
                } else {
                  this._cS.displayMessage(
                    ResponseMessageStatus.success,
                    res.message
                  );
                }
              }
            });
          } else {
            this._cS.displayMessage(
              ResponseMessageStatus.error,
              'Please select stock to proceed'
            );
          }
        }
      } else {
        this._cS.displayMessage(
          ResponseMessageStatus.info,
          'At least one stock should be needed for assignemnt.'
        );
      }
    } else {
      this.editAssignmentDetail.stocks =
        this.lst_AddedStock && this.lst_AddedStock.length > 0
          ? this.lst_AddedStock
          : [];
      if (this.editAssignmentDetail.note != formValue.notes) {
        this._blS
          .SaveAssignmentNotes(this.editAssignmentDetail.id, formValue.notes)
          .subscribe((res) => {
            if (res) {
              if (res.responseStatus == ResponseStatus.Success) {
                this.editAssignmentDetail.note = formValue.notes;
                this.editAssignmentDetail.purchaseOrder =
                  formValue.purchaseOrder;
              }
            }
          });
      }
      this.handleCancel(this.editAssignmentDetail);
    }
  }

  handleCancel(data?: any): void {
    this.isVisible = false;
    this.hideModal.emit({ hide: true, data: data ? data : null });
    const queryParams: Params = {};
    this._router.navigate([], {
      queryParams: queryParams,
      queryParamsHandling: '', // remove to replace all query params by provided
    });
  }

  hideShowAddStock(event: any) {
    this.isStockPopOver = event;
    this._fS.addAssignmentStockForm.reset();
    this.lst_Parts = [];
    // if (this.isStockPopOver) this.getStockList();
  }

  addStockToAssignment() {
    this._cS.markFormGroupTouched(this._fS.addAssignmentStockForm);
    if (this._fS.addAssignmentStockForm.valid) {
      var formValue = this._fS.addAssignmentStockForm.value;
      var stockName = this.lst_Stock.find(
        (x: any) => x.value == formValue.stockName
      ).text;
      this.checkQuantity();
      // if (this.editAssignmentDetail) {
      // } else {
      //   this.addEditStockPart(stockName, formValue);
      // }
      if (!this.isPartNumberExist) {
        this.addEditStockPart(stockName, formValue);
        this.lst_AddedStock = [...this.lst_AddedStock];
        this._fS.addAssignmentStockForm.reset();
        this.hideShowAddStock(false);
      }
    }
  }

  addEditStockPart(stockName: string, formValue: any) {
    this.checkQuantity();
    var qunatity = formValue.partQuantity ? formValue.partQuantity : 0;
    this.isQuantityExists = qunatity == 0 ? true : this.isQuantityExists;
    if (!this.isQuantityExists) {
      var stockIndex = this.lst_AddedStock.findIndex(
        (x: any) => x.name == stockName
      );
      if (stockIndex == -1) {
        if (this.editAssignmentDetail) {
          //i need to code here
          this.addStockPartEditTime(stockName, formValue);
        } else {
          var lstPart = [];
          lstPart.push({
            partNumber: formValue.partNumber,
            assignedQuantity: formValue.partQuantity,
          });
          this.lst_AddedStock.push({
            id: formValue.stockName,
            name: stockName ? stockName : '',
            partNumbers: lstPart,
          });
        }
      } else {
        var partIndex = this.lst_AddedStock[stockIndex].partNumbers.findIndex(
          (x: any) => x.partNumber == formValue.partNumber
        );
        if (partIndex > -1) {
          this.isPartNumberExist = true;
        } else {
          this.isPartNumberExist = false;
          if (this.editAssignmentDetail) {
            this.addStockPartEditTime(stockName, formValue);
          } else {
            this.lst_AddedStock[stockIndex].partNumbers.push({
              partNumber: formValue.partNumber,
              assignedQuantity: formValue.partQuantity,
            });
          }
        }
        this.lst_AddedStock[stockIndex].partNumbers = [
          ...this.lst_AddedStock[stockIndex].partNumbers,
        ];
      }
    } else {
      this._cS.displayMessage(
        ResponseMessageStatus.warning,
        'Entered part quantity is greater then available part in the stock'
      );
    }
  }

  addStockPartEditTime(stockName: string, formValue: any) {
    var body = {
      assignmentId: this.editAssignmentDetail.id,
      stockId: formValue.stockName,
      partNumber: formValue.partNumber,
      assignedQuantity: formValue.partQuantity ? formValue.partQuantity : 0,
    };
    this._blS.AddAssignmentStock(body).subscribe((res) => {
      if (res) {
        if (res.responseStatus == ResponseStatus.Success && res.result) {
          var stockIndex = this.lst_AddedStock.findIndex(
            (x: any) => x.name == stockName
          );
          var lstPart: any = [];
          if (stockIndex > -1) {
            lstPart = this.lst_AddedStock[stockIndex].partNumbers;
            lstPart.push({
              partNumber: formValue.partNumber,
              assignedQuantity: formValue.partQuantity,
            });
            this.lst_AddedStock[stockIndex].partNumbers = lstPart;
            this.lst_AddedStock[stockIndex].partNumbers = [
              ...this.lst_AddedStock[stockIndex].partNumbers,
            ];
          } else {
            lstPart.push({
              partNumber: formValue.partNumber,
              assignedQuantity: formValue.partQuantity,
            });
            // this.lst_AddedStock.push({
            //   id: formValue.stockName,
            //   name: stockName ? stockName : '',
            //   partNumbers: lstPart,
            // });
            this.lst_AddedStock.push(res.result[0]);
            this.lst_AddedStock = [...this.lst_AddedStock];
          }
          this._cS.displayMessage(ResponseMessageStatus.success, res.message);
        } else {
          this._cS.displayMessage(ResponseMessageStatus.error, res.message);
        }
      }
    });
  }

  getCustomerList() {
    try {
      this._blS.GetCustomerDropdown().subscribe((res) => {
        if (res) {
          if (res.responseStatus == ResponseStatus.Success && res.result) {
            this.lst_Customer = res.result;
          } else {
            this._cS.displayMessage(ResponseMessageStatus.error, res.message);
          }
        }
      });
    } catch (error) {}
  }

  removePartNumber(p: any, n: number, part?: any) {
    this.isStockSelected = true;
    if (this.lst_AddedStock.length == 1) {
      this._cS.displayMessage(
        ResponseMessageStatus.info,
        'At least one part number of stock should be needed for assignment.'
      );
    } else {
      if (this.editAssignmentDetail) {
        this._blS
          .DeleteAssignmentPartNumber(
            this.editAssignmentDetail.id,
            p.stockId,
            this.lst_AddedStock[n].partNumber
          )
          .subscribe((res) => {
            if (res) {
              if (res.responseStatus == ResponseStatus.Success && res.result) {
                this._cS.displayMessage(
                  ResponseMessageStatus.success,
                  res.message
                );
                this.lst_AddedStock = this.lst_AddedStock.filter(
                  (x: any) => x.id != p.id
                );
                if (this.invalidstocks?.includes(part?.partNumber)) {
                  this.invalidstocks = this.invalidstocks?.filter(
                    (x: any) => x == part?.partNumber
                  );
                }
              } else {
                this._cS.displayMessage(
                  ResponseMessageStatus.error,
                  res.message
                );
              }
            }
          });
      } else {
        if (part) {
          this.lst_AddedStock.forEach((element: any, assignmentIndex: any) => {
            var tempPartIndex = element.partNumbers.findIndex(
              (x: any) => x.partNumber == part.partNumber
            );
            if (tempPartIndex != -1) {
              partIndex = tempPartIndex;
              this.lst_AddedStock[assignmentIndex].partNumbers.splice(
                partIndex,
                1
              );
              if (
                this.lst_AddedStock[assignmentIndex].partNumbers.length == 0
              ) {
                this.lst_AddedStock.splice(assignmentIndex, 1);
              }
            }
            if (this.invalidstocks?.includes(part?.partNumber)) {
              this.invalidstocks = this.invalidstocks?.filter(
                (x: any) => x !== part.partNumber
              );
            }
            if (this.invalidstocks.length == 0) {
              this.isValidStockSelected = true;
            }
          });
        } else {
          var assigIndex = this.lst_AddedStock.findIndex(
            (x: any) => x.id == p.id
          );
          if (assigIndex > -1) {
            this.lst_AddedStock[assigIndex]?.partNumbers.splice(n, 1);
            if (this.lst_AddedStock[assigIndex]?.partNumbers.length == 0) {
              this.lst_AddedStock.splice(assigIndex, 1);
            }
          }
          this.lst_AddedStock = [...this.lst_AddedStock];
          var partIndex: any;
        }
      }
      this.lst_AddedStock.forEach((element: any) => {
        if (!element.id) {
          this.isStockSelected = false;
        }
      });
    }
  }

  onSelectCustomer(event: any) {
    try {
      this._fS.addUpdateAssignmentForm.patchValue({
        invoiceId: null,
      });
      this.lst_Invoice = [];
      this._blS.GetCustomerInvoiceDropdown(event).subscribe((res) => {
        if (res) {
          if (res.responseStatus == ResponseStatus.Success && res.result) {
            this.lst_Invoice = res.result;
          } else {
            this._cS.displayMessage(ResponseMessageStatus.error, res.message);
          }
        }
      });
    } catch (error) {}
  }

  getStockList() {
    try {
      this._blS.GetStockDropdown().subscribe((res) => {
        if (res) {
          if (res.responseStatus == ResponseStatus.Success && res.result) {
            this.lst_Stock = res.result;
            this.lst_Stock_Qty = this.lst_Stock;
          } else {
            this._cS.displayMessage(ResponseMessageStatus.error, res.message);
          }
        }
      });
    } catch (error) {}
  }
  getStockListWithQty(partNumber: any) {
    this.isLoadingList = true;
    this.lst_Stock_Qty = [];
    try {
      this._blS.GetStockDropdownWithQty(partNumber).subscribe((res) => {
        if (res) {
          if (res.responseStatus == ResponseStatus.Success && res.result) {
            this.lst_Stock_Qty = res.result;
            this.isLoadingList = false;
          } else {
            this.isLoadingList = false;
            this._cS.displayMessage(ResponseMessageStatus.error, res.message);
          }
        }
      });
    } catch (error) {}
  }

  onSelectStock(event: any, p?: any, n?: any) {
    var currentStockName = this.lst_Stock.find(
      (x: any) => x.value == event
    )?.text;
    if (p) {
      this.currectStockId = p.stockId;
      var findIndex = this.lst_AddedStock?.findIndex(
        (x: any, i: any) =>
          x.stockId == p.stockId && x.partNumber == p.partNumber && i != n
      );
    }
    if (findIndex > -1) {
      this.isValidStockSelected = false;
      this._cS.displayMessage(
        ResponseMessageStatus.error,
        `Selected stock and part number is already in list please select another stock`
      );
    } else {
      if (event) {
        try {
          this.isStockSelected = true;
          this.lst_AddedStock.forEach((element: any) => {
            if (!element.id) {
              this.isStockSelected = false;
            }
          });
          this._fS.addAssignmentStockForm.patchValue({
            partNumber: null,
          });
          if (p) {
            this.isValidStockSelected = this.checkIfValidStockSelected(
              event,
              p,
              currentStockName
            );
          } else {
            this.lst_Parts = [];
            this._blS.GetStockPartDropdown(event).subscribe((res) => {
              if (res) {
                if (
                  res.responseStatus == ResponseStatus.Success &&
                  res.result
                ) {
                  this.lst_Parts = res.result;
                } else {
                  this._cS.displayMessage(
                    ResponseMessageStatus.error,
                    res.message
                  );
                }
              }
            });
          }
          // }
        } catch (error) {}
      }
    }
  }
  invalidstocks: any[] = [];
  checkIfValidStockSelected(selectedStockId: any, part: any, stockName?: any) {
    var stockAssignmentBody = {
      id: part?.id,
      assignmentId: part?.assignmentId,
      stockId: selectedStockId,
      partNumber: part?.partNumber,
      assignedQuantity: part.assignedQuantity || 0,
    };
    if (part.assignedQuantity) {
      // if (selectedStockId != '64e2ede989f2cc30cb03ff0c') {
      this._blS.ValidateAssignmentStock(stockAssignmentBody).subscribe(
        (res: any) => {
          if (ResponseStatus.Success == res.responseStatus) {
            this.isValidStockSelected = true;
            this.invalidstocks = this.invalidstocks.filter(
              (p: any) => p != part.partNumber
            );
            var q = this.lst_Stock.find((x: any) => x.value == selectedStockId);
            var changedst = this.lst_AddedStock.findIndex(
              (x: any) => x.stockId == selectedStockId
            );
            if (changedst != -1) {
              this.lst_AddedStock[changedst].stockName = q.text;
            }
            this._cS.displayMessage(ResponseMessageStatus.success, res.message);
          } else {
            this.isValidStockSelected = false;
            res.message.includes('quantity')
              ? (this.isNumberField = true)
              : (this.isNumberField = false);

            if (!this.invalidstocks.includes(part.partNumber))
              this.invalidstocks.push(part.partNumber);
            this._cS.displayMessage(ResponseMessageStatus.error, res.message);
          }
          if (this.invalidstocks.length != 0) {
            this.isValidStockSelected = false;
          }
        },
        (err: any) => {
          this.isValidStockSelected = false;
          if (!this.invalidstocks.includes(part.partNumber))
            this.invalidstocks.push(part.partNumber);
          this._cS.displayMessage(ResponseMessageStatus.error, err.message);
        }
      );
      // } else {
      //   this.invalidstocks = [];
      // }
      return true;
    } else {
      this.isValidStockSelected = false;
      this.isNumberField = true;
      if (!this.invalidstocks.includes(part.partNumber))
        this.invalidstocks.push(part.partNumber);
      this._cS.displayMessage(
        ResponseMessageStatus.error,
        `Entered part quantity can't be empty`
      );
      return true;
    }
  }
  checkQuantity() {
    var formValue = this._fS.addAssignmentStockForm.value;
    if (
      formValue.partNumber &&
      formValue.stockName != '64e2ede989f2cc30cb03ff0c'
    ) {
      var find = this.lst_Parts.find(
        (x: any) => x.value == formValue.partNumber
      );
      if (formValue.partQuantity > find.availableQuantity) {
        formValue.partQuantity = null;
        this.isQuantityExists = true;
        this._cS.displayMessage(
          ResponseMessageStatus.warning,
          'Entered part quantity is greater than available part in the stock'
        );
      } else this.isQuantityExists = false;
    } else {
      this.isQuantityExists = false;
    }
  }

  onSelectPartNumber(event: any) {
    if (this.editAssignmentDetail) {
      var stockIndex = this.lst_AddedStock.findIndex(
        (x: any) =>
          x.partNumber == this._fS.addAssignmentStockForm.value.partNumber &&
          x.stockId == this._fS.addAssignmentStockForm.value.stockName
      );
      this.isPartNumberExist = stockIndex > -1 ? true : false;
      //   if (stockIndex > -1 && this.lst_Parts.length > 0) {
      //     var part = this.lst_Parts.find((p: any) => p.value == event);
      //     if (part)
      //       this.isPartNumberExist = part.text == this.lst_AddedStock[stockIndex].partNumber ? true : false;
      //   } else {
      //     this.isPartNumberExist = false;
      //   }
    } else {
      var stockIndex = this.lst_AddedStock.findIndex(
        (x: any) => x.id == this._fS.addAssignmentStockForm.value.stockName
      );

      if (stockIndex > -1 && this.lst_Parts.length > 0) {
        var part = this.lst_Parts.find((p: any) => p.value == event);
        if (part)
          var partIndex = this.lst_AddedStock[stockIndex].partNumbers.findIndex(
            (x: any) => x.partNumber == part.text
          );
        this.isPartNumberExist = partIndex > -1 ? true : false;
      } else {
        this.isPartNumberExist = false;
      }
    }
  }

  syncLatestCustomers() {
    this.isSyncCustomer = true;
    this._blS.SyncLatestCustomers().subscribe((res) => {
      if (res) {
        if (res.result && res.responseStatus == ResponseStatus.Success) {
          this.lst_Customer = res.result;
        }
        this.isSyncCustomer = false;
      }
    });
  }

  syncLatestInvoices() {
    if (this._fS.addUpdateAssignmentForm.get('customerId')?.value) {
      this.isSyncInvoice = true;
      this._blS
        .SyncLatestInvoices(
          this._fS.addUpdateAssignmentForm.get('customerId')?.value
        )
        .subscribe((res) => {
          if (res) {
            if (res.result && res.responseStatus == ResponseStatus.Success) {
              this.lst_Invoice = res.result;
            }
            this.isSyncInvoice = false;
          }
        });
    } else {
      this._cS.displayMessage(
        ResponseMessageStatus.info,
        'Please select customer for fetch invoice numbers'
      );
    }
  }
  //#endregion
  constructor(
    public _fS: FormsService,
    public _cS: CommonService,
    private _blS: BadeLoftService,
    private _router: Router,
    private cdref: ChangeDetectorRef
  ) {
    if (!this.editAssignmentDetail) {
      _fS.addUpdateAssignmentForm_fb();
    }
    _fS.addAssignmentStockForm_fb();
  }
  loadCurrentStockPartsData() {
    this.isPartsLoading = true;
    if (this.editAssignmentDetail) {
      if (this.editAssignmentDetail?.assigmentDetails) {
        this._blS
          .GetEditAssignmentStocksDetail(
            this.editAssignmentDetail.id
              ? this.editAssignmentDetail.id
              : this.editAssignmentDetail.assignmentId
          )
          .subscribe((res) => {
            if (res) {
              if (res.result && res.responseStatus == ResponseStatus.Success) {
                this.editAssignmentDetail = res.result.assignments;
                this.lst_AddedStock = res.result.assignmentStocks;
                this.lst_AddedStock = this.lst_AddedStock.filter(
                  (x: any) => x.partNumber != null
                );
                this._fS.addUpdateAssignmentForm.patchValue({
                  customerId: this.editAssignmentDetail
                    ? this.editAssignmentDetail.customerName
                    : null,
                  invoiceId: this.editAssignmentDetail.invoiceNo
                    ? this.editAssignmentDetail.invoiceNo
                    : null,
                  notes: this.editAssignmentDetail.note
                    ? this.editAssignmentDetail.note
                    : '',
                  purchaseOrder: this.editAssignmentDetail.poNumber
                    ? this.editAssignmentDetail.poNumber
                    : '',
                });
              }
            }
            this.isPartsLoading = false;
          });
      } else {
        this._blS
          .GetAssignmentStock(
            this.editAssignmentDetail.id
              ? this.editAssignmentDetail.id
              : this.editAssignmentDetail.assignmentId
          )
          .subscribe((res) => {
            if (res) {
              if (res.result && res.responseStatus == ResponseStatus.Success) {
                this.lst_AddedStock = res.result;
                this.lst_AddedStock = this.lst_AddedStock.filter(
                  (x: any) => x.partNumber != null
                );
                // this.lst_AddedStock.forEach((stockPart: any) => {
                //   this.getStockListWithQty(stockPart.partNumber);
                // });
              }
            }
            this.isPartsLoading = false;
          });
      }
      this._fS.addUpdateAssignmentForm.get('customerId')?.disable();
      this._fS.addUpdateAssignmentForm.get('invoiceId')?.disable();
      this._fS.addUpdateAssignmentForm.patchValue({
        customerId: this.editAssignmentDetail
          ? this.editAssignmentDetail.customerName
          : null,
        invoiceId: this.editAssignmentDetail.invoiceNo
          ? this.editAssignmentDetail.invoiceNo
          : null,
        notes: this.editAssignmentDetail.note
          ? this.editAssignmentDetail.note
          : '',
        purchaseOrder: this.editAssignmentDetail.poNumber
          ? this.editAssignmentDetail.poNumber
          : '',
      });
      if (this.editAssignmentDetail.stocks != null) {
        this.lst_AddedStock =
          this.editAssignmentDetail &&
          this.editAssignmentDetail.stocks.length > 0
            ? this.editAssignmentDetail.stocks
            : [];
      }
    }
  }

  fillInvoiceDataInTextBox(item: any) {
    if (!this.editAssignmentDetail && !item.isAssigned) {
      this._fS.addUpdateAssignmentForm.patchValue({
        invoiceId: item.invoiceNo,
        customerId: item.customerName,
      });
      this.dataToPassInSaveAssignment = {
        customerID: item.customerID,
        customerName: item.customerName,
        transactionID: item.transactionID,
        invoiceNo: item.invoiceNo,
      };
    }
    this.fetchCustomer();
  }
  fetchCustomer() {
    this.lst_AddedStock = [];
    var invoiceNumber =
      this._fS.addUpdateAssignmentForm.get('invoiceId')?.value;
    if (invoiceNumber) {
      this._blS.GetInvoiceByNumber(invoiceNumber).subscribe(
        (res: any) => {
          if (res) {
            if (res.result && ResponseStatus.Success) {
              this.invoiceNotExist = false;
              this._fS.addUpdateAssignmentForm.patchValue({
                customerId: res.result.customerName,
                purchaseOrder: res.result.poNumber,
              });
              this.dataToPassInSaveAssignment = {
                customerID: res.result.customerID,
                customerName: res.result.customerName,
                transactionID: res.result.transactionID,
                invoiceNo: res.result.invoiceNo,
              };
              if (this.editAssignmentDetail) {
                this.lst_AddedStock = res.result.assignmentStockPartNumber;
              } else {
                res.result.assignmentStockPartNumber.forEach((element: any) => {
                  if (element.partNumber != null) {
                    this.lst_AddedStock.push({ partNumbers: [element] });
                  }
                });
              }
            } else {
              this.invoiceNotExist = true;
              this._fS.addUpdateAssignmentForm.patchValue({
                customerId: '',
              });
              this._cS.displayMessage(ResponseMessageStatus.error, res.message);
            }
          } else {
            this.invoiceNotExist = true;
            this._fS.addUpdateAssignmentForm.patchValue({
              customerId: '',
            });
            this._cS.displayMessage(ResponseMessageStatus.error, res.message);
          }
        },
        (err: any) => {
          this.invoiceNotExist = true;
          this._fS.addUpdateAssignmentForm.patchValue({
            customerId: '',
          });
          this._cS.displayMessage(ResponseMessageStatus.error, err.message);
        }
      );
    }
  }
  getLatestCreatedInvoices() {
    this.isDataLoaded = true;
    this._blS.GetLatestCreatedInvocies().subscribe(
      (res: any) => {
        if (res) {
          if (res.result && res.responseStatus == ResponseStatus.Success) {
            this.latestInvoices = res.result;
            this.isDataLoaded = false;
          } else {
            this.isDataLoaded = false;
            this._cS.displayMessage(ResponseMessageStatus.error, res.message);
          }
        } else {
          this.isDataLoaded = false;
          this._cS.displayMessage(ResponseMessageStatus.error, res.message);
        }
      },
      (err: any) => {
        this.isDataLoaded = false;
        this._cS.displayMessage(ResponseMessageStatus.error, err.message);
      }
    );
  }

  getLastMonthUnAssignInvoice() {
    this.isDataLoaded = true;
    this._blS.GetLastMonthUnAssignInvoices().subscribe(
      (res: any) => {
        if (res) {
          if (res.result && res.responseStatus == ResponseStatus.Success) {
            this.latestInvoices = res.result;
            this.isDataLoaded = false;
          } else {
            this.isDataLoaded = false;
            this._cS.displayMessage(ResponseMessageStatus.error, res.message);
          }
        } else {
          this.isDataLoaded = false;
          this._cS.displayMessage(ResponseMessageStatus.error, res.message);
        }
      },
      (err: any) => {
        this.isDataLoaded = false;
        this._cS.displayMessage(ResponseMessageStatus.error, err.message);
      }
    );
  }

  changeassignmentInvoiceType() {
    if (this.radioValue == '1') {
      this.getLatestCreatedInvoices();
    } else {
      this.getLastMonthUnAssignInvoice();
    }
  }
  isAscPart: boolean = true;
  sortPart(isAsc: any) {
    this.isAscPart = isAsc;
    var ar = this.lst_AddedStock.sort(function (a: any, b: any) {
      var nA = isAsc ? a.partNumber.toLowerCase() : b.partNumber.toLowerCase();
      var nB = isAsc ? b.partNumber.toLowerCase() : a.partNumber.toLowerCase();

      if (nA < nB) return -1;
      else if (nA > nB) return 1;
      return 0;
    });
    this.lst_AddedStock = ar;
  }

  ngOnInit(): void {
    if (!this.editAssignmentDetail) {
      this.getLatestCreatedInvoices();
    }
    this.loadCurrentStockPartsData();
    this.getStockList();
    if (this.assignemntForInvoice) {
      this._fS.addUpdateAssignmentForm.patchValue({
        invoiceId: this.assignemntForInvoice.invoiceNumber,
        customerId: this.assignemntForInvoice.customerID,
        purchaseOrder: this.assignemntForInvoice.po,
      });
      this._fS.addUpdateAssignmentForm.get('invoiceId')?.disable();
      this.fetchCustomer();
    }
  }
  // to avoid expression ng-zorro error
  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.showModal();
    }, 100);
  }
}
